import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import AdminLayout from '@/components/AdminLayout'
import BlogCategoryForm, { type BlogCategoryFormData } from '@/components/admin/BlogCategoryForm'

type Props = {
  category: { name: string; slug: string; description: string; position: number }
  errors?: Partial<Record<string, string[] | string>>
}

export default function AdminBlogCategoriesNew({ category, errors }: Props) {
  const initialData: BlogCategoryFormData = {
    name: category.name,
    slug: category.slug,
    description: category.description,
    position: category.position,
  }
  return (
    <>
      <Head title="Admin · New blog category" />
      <BlogCategoryForm initialData={initialData} errors={errors} />
    </>
  )
}

AdminBlogCategoriesNew.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>
